// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O34lZ{display:flex;flex-direction:column;gap:.5rem;position:relative}.O34lZ .hN70x,.O34lZ .o6UyI{flex-basis:100%}.O34lZ.iLDl6,.O34lZ.PUse8{align-items:baseline;flex-flow:row wrap;gap:0 1.5rem}.O34lZ.iLDl6 .o6UyI{flex-basis:auto}.O34lZ.iLDl6:not(.PUse8){--radio-group-label-max-width:8rem;row-gap:.5rem}.O34lZ.iLDl6:not(.PUse8) .o6UyI{max-width:var(--radio-group-label-max-width);position:absolute}.O34lZ.iLDl6:not(.PUse8) .hN70x,.O34lZ.iLDl6:not(.PUse8) .svyNZ.ui.radio{flex-basis:100%;margin-left:var(--radio-group-label-max-width)}.svyNZ.ui.radio:after{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `O34lZ`,
	"error": `hN70x`,
	"label": `o6UyI`,
	"inlineField": `iLDl6`,
	"inlineOptions": `PUse8`,
	"option": `svyNZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
